import React, { useEffect, useState } from "react";
import GroupedBarChart from "../../../CHARTS/GroupedBarChart";
import StackedColumnChart from "../../../CHARTS/StackedColumnChart";
import NoDataFound from "../../../Extra/NoDataFound";
const TotalBar = ({ chartData, from, status, targetData }) => {
  const [sumData, setSumData] = useState(null);
  const [stackedData, setStackedData] = useState(null);
  function getTotalChartData(chartData) {
    if (!chartData || !Array.isArray(chartData.series)) return null;

    // Auto-detect numeric keys from dimensions (excluding 'product')
    const keysToSum = chartData.dimensions.filter((key) => key !== "product");

    const totalEntry = { product: "Total" };

    keysToSum.forEach((key) => {
      totalEntry[key] = chartData.series
        .reduce((sum, item) => {
          const val = parseFloat(item[key]);
          return sum + (isNaN(val) ? 0 : val);
        }, 0)
        .toFixed(2); // rounded to 2 decimal places
    });

    return {
      dimensions: chartData.dimensions,
      series: [totalEntry],
    };
  }

  useEffect(() => {
    if (chartData) {
      const sd = getTotalChartData(chartData);
      setSumData(sd);
    }
  }, [chartData]);
  const stackedChartData = (data, fyWiseSummary) => {
    let keyName = from === "CHWeight" ? "tgt_ch" : "tgt_wgn";
    let tempDimensions = [...data.dimensions];
    tempDimensions.splice(0, 1); // remove first element (like "product")

    //  decide how to rename FY keys
    const renameFY = (fy) => {
      const maxFY = Math.max(
        ...Object.keys(fyWiseSummary).map((f) => parseInt(f.split("_")[0], 10))
      );
      if (fy.startsWith(maxFY.toString())) return "Current Year";
      return "Previous Year";
    };

    let tempSeries = [];

    tempDimensions.forEach((dim, idx) => {
      if (dim.toLowerCase().includes("target")) {
        const fy = dim.replace("_target", "");
        const displayFY = renameFY(fy);

        if (fyWiseSummary[fy]) {
          const actualIdx = tempDimensions.indexOf(fy);

          // 1. Remaining → aligned with actual column
          tempSeries.push({
            name: `${displayFY} Remaining`,
            data: tempDimensions.map((_, i) =>
              i === actualIdx
                ? Math.max(
                    fyWiseSummary[fy][keyName] - (data.series[0][fy] || 0),
                    0
                  )
                : 0
            ),
          });

          // 2. Target → aligned with target column
          tempSeries.push({
            name: `${displayFY} Target`,
            data: tempDimensions.map((_, i) =>
              i === idx ? fyWiseSummary[fy][keyName] : 0
            ),
          });
        }
      } else {
        // Actual
        const displayFY = renameFY(dim);
        tempSeries.push({
          name: displayFY,
          data: tempDimensions.map((_, i) =>
            i === idx ? data.series[0][dim] || 0 : 0
          ),
        });
      }
    });

    setStackedData({
      categories: tempDimensions,
      series: tempSeries,
    });
  };

  useEffect(() => {
    const fyWiseSummary = targetData.reduce((acc, item) => {
      if (
        status.Commodity.includes(item.commodity) &&
        status.months.includes(item.month) &&
        status.years.includes(item.f_year)
      ) {
        if (!acc[item.f_year]) {
          acc[item.f_year] = { tgt_ch: 0, tgt_wgn: 0 };
        }
        acc[item.f_year].tgt_ch += parseFloat(item.tgt_ch);
        acc[item.f_year].tgt_wgn += parseFloat(item.tgt_wgn);
      }
      return acc;
    }, {});

    if (sumData && Object.keys(fyWiseSummary).length > 0) {
      stackedChartData(sumData, fyWiseSummary);
    }
  }, [sumData, status?.years, status?.months, status?.commodity, targetData]);
  return (
    <div>
      <h6 className="m-1 p-2 bg-dark text-white">Summary of Data </h6>

      {/* {sumData ? (
        <GroupedBarChart
          data={sumData}
          // yearDif={yearDif}
          from={`7A${from}`}
          chartType={"bar"}
        />
      ) : (
        "No Data Found"
      )} */}
      {stackedData ? (
        <StackedColumnChart
          data={stackedData}
          height={"410px"}
          from={from}
          needTotal={"no"}
        />
      ) : (
        <NoDataFound />
      )}
      <b style={{ color: "gray", fontSize: "12px" }}>
        {" "}
        target data does not update as per the selection of the stations{" "}
      </b>
    </div>
  );
};
export default TotalBar;
